
<div class="w-100 pa-0 pt-1">
    <div class="v-flex">
        <div class="lm-border mr-2 pa-2 pb-1" style="width: 150px">
            <c-inspection-scope-compact
                :inspection = "inspection"
                @menu       = "onMenu"
            />
        </div>
        <div class="lm-border disposition-header" style="width: calc(100% - 150px)">
            <v-row dense>
                <v-col dense class="col-6 pr-1">
                    <f-read-only-field
                        label  = "Gutachter"
                        :value = "inspection.technicianName ? inspection.technicianName : '---'"
                        filled
                        dense
                    />
                </v-col>

                <v-col class="col-3 pl-1 pr-1">
                    <f-read-only-field
                        label  = "Status"
                        :value = "inspection.done ? $t('disposition.status.done') : $t('disposition.status.inProcess')"
                        filled
                        dense
                    />
                </v-col>

                <v-col class="col-3 pl-1">
                    <f-read-only-field
                        :label = "$t('disposition.inspection.created')"
                        :value = "formatDateTime(inspection.createdDate)"
                        filled
                        dense
                    />
                </v-col>
            </v-row>

            <v-row dense class="mt-2">
                <v-col class="col-3 pr-1">
                    <f-read-only-field
                        :label = "$t('disposition.inspection.id')"
                        :value = "elevatorId"
                        filled
                        dense
                    />
                </v-col>
                <v-col class="col-3 pl-1 pr-1">
                    <f-date-picker
                        v-if    = "!inspection.download"
                        label   = "disposition.inspection.date"
                        :time   = "false"
                        v-model = "inspection.inspectionDate"
                        @input  = "onInspectionDate"
                    />
                    <f-read-only-field
                        v-if="inspection.download"
                        :label = "$t('disposition.inspection.date')"
                        :value = "formatDate(inspection['inspectionDate'])"
                        filled
                        dense
                    />
                </v-col>

                <v-col class="col-3 pl-1 pr-1">
                    <f-read-only-field
                        :label = "$t('disposition.inspection.download')"
                        :value = "formatDateTime(inspection.download)"
                        filled
                        dense
                    />
                </v-col>
                <v-col class="col-3 pl-1">
                    <f-read-only-field
                        :label = "$t('disposition.inspection.lastUpload')"
                        :value = "formatDateTime(inspection.upload)"
                        filled
                        dense
                    />
                </v-col>
            </v-row>
        </div>
    </div>

    <div class="w-100 mt-2">

        <div class="mt-2 w-100">
            <div
                v-if        = "page === 'CONTACTS'"
            >
                <div class="v-flex">
                    <div class=" w-50 mb-4 pr-2">
                        <c-column-header
                            label = "Bemerkungen"
                            class="primary white--text"
                            :title-border = "true"
                        >
                            <template v-slot:toolbar>
                                <c-toolbar-button
                                    icon="mdi-content-save"
                                    color="white"
                                    size="20"
                                    style="margin-top: -1px; padding-right: 4px;"
                                    @click = "onStore"
                                    tooltip="Bemerkung speichern"
                                />
                            </template>
                        </c-column-header>
                        <div class="lm-border bottom-border-radius pa-2" style="border-top-style: none; height: 150px">
                            <v-textarea
                                v-model        = "inspection.comment"
                                rows           = "5"
                                autocomplete   = "off"
                                autocorrect    = "off"
                                autocapitalize = "off"
                                spellcheck     = "false"
                                class          = "pt-0"
                                no-resize
                                hide-details
                            />
                        </div>

                    </div>
                    <div class=" w-50 mb-2 pl-2">
                        <c-column-header
                            label = "Verwender"
                            class="primary white--text"
                            :title-border = "true"
                        >
                        </c-column-header>

                        <div class="lm-border bottom-border-radius pa-2" style="border-top-style: none; height: 150px">
                        </div>

                    </div>
                </div>

                <c-inspection-contacts
                    :inspection = "inspection"
                    :height     = "height"
                />

            </div>

            <p-disposition-elevator-data
                v-if        = "page === areas.UNIT"
                :inspection = "inspection"
                :height     = "height"
                @refresh    = "onRefresh"
            />

            <p-disposition-sticker
                v-if        = "page === areas.STICKER"
                :inspection = "inspection"
                :height     = "height"
            />

            <p-disposition-lift-guardian
                v-if        = "page === areas.LGS"
                :inspection = "inspection"
                :height     = "height"
            />

            <p-disposition-condition
                v-if        = "page === areas.CONDITIONS"
                :inspection = "inspection"
                :height     = "height"
            />

            <c-disposition-audit
                v-if        = "page === areas.GBU"
                :type       = "areas.GBU"
                :inspection = "inspection"
                :height     = "height"
            />

            <c-disposition-audit
                v-if        = "page === areas.ESG"
                :type       = "areas.ESG"
                :inspection = "inspection"
                :height     = "height"
            />

            <c-inspection-images
                v-if        = "page === areas.BOOK"
                type        = "BOOK"
                :title      = "$t('disposition.book.menu')"
                :key        = "page"
                :inspection = "inspection"
                :height     = "height"
            />

            <c-inspection-images
                v-if        = "page === areas.IMAGES"
                type        = "IMAGE"
                :title      = "$t('disposition.images.menu')"
                :key        = "page"
                :inspection = "inspection"
                :height     = "height"
            />
        </div>
    </div>
</div>
